exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@use '../../../colors';.floatingCartButton-container{bottom:0;position:fixed;display:flex;flex-direction:column;justify-content:center;border-radius:100%;background-color:var(--floating-cart-background-color);align-items:center;padding:8px;margin:8px;border-color:var(--floating-cart-border-color);border-style:solid;border-width:2px;z-index:130;cursor:pointer;width:50px}.checkoutTextStyles{color:var(--floating-cart-primary-color)}.floatingCartButton-cartBadge{right:0px;color:var(--badge-text);background-color:var(--badge-bg)}\n", ""]);

// exports
